module.exports = __webpack_public_path__ + "media/images/icon_user-e8ede062fea7020503490fac02620cf0.svg";